import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'positionToPoints'
})
export class PositionToPointsPipe implements PipeTransform {

  transform(position: number | null | undefined, pointsMap: number[]): number {
    if (!position || pointsMap.length < 1) {
      return 0;
    } else if (position <= pointsMap.length) {
      return pointsMap[position - 1];
    } else {
      return pointsMap[pointsMap.length - 1];
    }
  }
}
